import { BASE_URL, callApi, executeActionsResponse, executeActionsError, getToken, getRefreshToken } from './apiMiddlewareCommon';
import type { CallApiPayload } from './apiMiddlewareCommon';
import type { Middleware } from 'redux';

export { BASE_URL, callApi, executeActionsResponse, executeActionsError, getToken, getRefreshToken };

export const CALL_API = 'CALL_API';

const ApiMiddleware: Middleware = (store) => (next) => (action) => {
  const callAPI: CallApiPayload | undefined = action[CALL_API];

  // So the middleware doesn't get applied to every single action
  if (typeof callAPI === 'undefined') {
    return next(action);
  }
  const {
    endpoint,
    types,
    authenticated,
    method,
    data,
    microservice,
    contentType,
    accept,
    customToken,
  } = callAPI;

  const { requestType, successTypes, errorTypes } = types;

  if (typeof requestType === 'object') {
    next(requestType);
  } else if (typeof requestType === 'function') {
    next(requestType());
  } else {
    next({
      type: requestType,
    });
  }

  const token = customToken ?? getToken(authenticated);

  // Passing the authenticated boolean back in our data will let us distinguish between normal and secret quotes
  return callApi({
    endpoint,
    authenticated,
    microservice,
    method,
    data,
    token,
    next,
    contentType,
    accept,
  })
    .then((response: any) => {
      return executeActionsResponse(next, response, successTypes);
    })
    .catch((error: any) => {
      return executeActionsError(next, error, errorTypes);
    });
};

export default ApiMiddleware;
